import { IconsListType } from "@backlight-dev/turnio.design-icons/Icons/types";
import React from "react";

import { ValueOf } from "ds/types";
import { RoleType } from "graphql/generated/types";

export const NavType = {
  MAIN: "main",
  FEATURE: "feature",
  ICON: "icon",
} as const;
export type TNavType = ValueOf<typeof NavType>;

export const NavsType = {
  VERTICAL: "vertical",
  HORIZONTAL: "horizontal",
} as const;
export type TNavsType = ValueOf<typeof NavsType>;

export interface NavItemProps {
  counter?: {
    value: number;
    unread?: boolean;
  };
  type?: TNavType;
  iconName?: IconsListType;
  rolesCanAccess?: RoleType[];
  text?: string;
  version?: string;
  current?: boolean;
  onClick?: () => void;
  anchor?: React.ComponentPropsWithoutRef<"a">;
}

export interface NavsProps extends React.ComponentPropsWithoutRef<"ul"> {
  type?: TNavsType;
  items: NavItemProps[];
}
